import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';

@observer
class StudioReadOnlyMessage extends Component {
    render() {
        return <div className="m-studio-readonly-wrapper">
            <div className="m-studio-readonly-header">
                <FormattedMessage id="studio.readonly.message.header"/>
            </div>
            <div className="m-studio-readonly-details">
                <FormattedMessage id="studio.readonly.message.details"/>
            </div>
        </div>;
    }
}

export default StudioReadOnlyMessage;
